import type { AspidaClient, BasicHeaders } from 'aspida';
import type { Methods as Methods_by08hd } from '.';

const api = <T>({ baseURL, fetch }: AspidaClient<T>) => {
  const prefix = (baseURL === undefined ? 'http://localhost:18081' : baseURL).replace(/\/$/, '');
  const PATH0 = '/v1/employee/login';
  const POST = 'POST';

  return {
    /**
     * 社員ログイン処理を行い、社員モード用の認証結果を返します。<br/>
     * 正しく認証できた場合は、社員モード用JWTとアカウント情報を返します。<br/>
     * @returns 正常処理
     */
    post: (option: { body: Methods_by08hd['post']['reqBody'], config?: T | undefined }) =>
      fetch<Methods_by08hd['post']['resBody'], BasicHeaders, Methods_by08hd['post']['status']>(prefix, PATH0, POST, option).json(),
    /**
     * 社員ログイン処理を行い、社員モード用の認証結果を返します。<br/>
     * 正しく認証できた場合は、社員モード用JWTとアカウント情報を返します。<br/>
     * @returns 正常処理
     */
    $post: (option: { body: Methods_by08hd['post']['reqBody'], config?: T | undefined }) =>
      fetch<Methods_by08hd['post']['resBody'], BasicHeaders, Methods_by08hd['post']['status']>(prefix, PATH0, POST, option).json().then(r => r.body),
    $path: () => `${prefix}${PATH0}`,
  };
};

export type ApiInstance = ReturnType<typeof api>;
export default api;
